import api from "../../lib/api";
import router from "../../router";
import i18n from "../../plugins/i18n";
export default {
  namespaced: true,
  state: {
    user: null
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    async changeLanguage({ dispatch }, payload) {
      let lang = payload.toLowerCase();
      dispatch("getLang", lang, { root: true });
    },
    async getUser({ dispatch }) {
      try {
        const response = await api.get("/me");
        const user = response.data;
        console.log(user, response);
        dispatch("setUser", { user });
      } catch (error) {
        console.error(error);
      }
    },
    setUser({ commit }, payload) {
      const { redirect, user } = payload;
      if (redirect && router.currentRoute.path !== redirect)
        router.push(redirect);
      if (router.currentRoute.path === "/login") router.push("/");
      commit("SET_USER", user);
    }
  },
  getters: {
    user: state => state.user,
    isAuthenticated: state => !!state.user,
    isAdmin: state => state.user && state.user.role === "admin",
    isSuperAdmin: state => state.user && state.user.role === "super_admin",
    isSiteManager: state => state.user && state.user.role === "site_manager"
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js